import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { RxForDoctorModule } from '@modules/rx-for-doctor/rx-for-doctor.module';
import { RxForLabModule } from '@modules/rx-for-lab/rx-for-lab.module';
import { PrintRxModule } from '@modules/print-rx/print-rx.module';
import { RxForModelingModule } from '@modules/rx-for-modeling/rx-for-modeling.module';
import { SharedModule } from '@shared/shared.module';
import { CommonModule } from '@angular/common';
import { RxIntuitiveForDoctorComponent } from '@modules/rx-intuitive/containers/rx-intuitive-for-doctor/rx-intuitive-for-doctor.component';
import { UnifiedPatientsModule, UNIFIED_PATIENTS_CONFIG } from '@modules/unified-patients';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { RegionClusterMapper } from '@shared/utils/region-cluster-mapper';
import { RxModeToggleBannerComponent } from '@modules/rx-intuitive/containers/rx-intuitive-for-doctor/components/rx-mode-toggle-banner/rx-mode-toggle-banner.component';
import { HostPlatformService } from '@shared/services/host-platform.service';
import { SessionType } from '@shared/models/consts';

@NgModule({
	declarations: [AppComponent],
	imports: [
		CommonModule,
		SharedModule,
		RxForDoctorModule,
		RxForLabModule,
		RxForModelingModule,
		PrintRxModule,
		RxIntuitiveForDoctorComponent,
		UnifiedPatientsModule,
		RxModeToggleBannerComponent
	],
	providers: [
		{
			provide: UNIFIED_PATIENTS_CONFIG,
			useFactory: (
				shell: ShellQuery,
				appSettings: AppSettingsService,
				regionMapper: RegionClusterMapper,
				hostPlatform: HostPlatformService
			) => ({
				getBasePath: () => shell.staticFilesEndpoint,
				getCompanyId: () => shell.companyId ?? 0,
				getContactId: () => shell.contactId ?? 0,
				getBffUrl: () => regionMapper.resolveBffUrl(appSettings.environmentParams ?? {}, shell.getValue().region) ?? '',
				getHostRxApiUrl: () => shell.apiEndpointFallback ?? '',
				getDateFormat: () => shell.dateFormat ?? 'MM/DD/YYYY',
				getDobMask: () => shell.regulatoryDOBMask ?? '',
				getEnvironment: () => appSettings.environmentParams?.signalFx?.environment ?? '',
				getRegion: () => regionMapper.map(shell.getValue().region) ?? '',
				getSessionType: () => (hostPlatform.isScanner ? SessionType.Desktop : SessionType.Web),
				getAppBISessionId: () => shell.appBISessionId ?? null
			}),
			deps: [ShellQuery, AppSettingsService, RegionClusterMapper, HostPlatformService]
		}
	],
	exports: [AppComponent]
})
export class AppModule {}
